import React from 'react'
import useTrans from '@hooks/useTrans'
import { PosizionePersonalizzazioneType } from '@utils/types'
import { cn } from '@utils/safeTs'
import styles from './FlussoPersonalizzazionePosizioneEditorInfo.module.sass'
import { parseFontSize } from '@utils/editor-bozze'


interface Props {
  posizione: PosizionePersonalizzazioneType
  className?: string
}

const FlussoPersonalizzazionePosizioneEditorInfo = (props: Props) => {

  const { 
    posizione,
    className = '',
  } = props

  const t = useTrans()

  const objectsData = posizione?.editorState?.objectsData || []
  const loghi = objectsData.filter((object) => object.type === 'image')
  const testi = objectsData.filter((object) => object.type === 'text')

  if (!objectsData.length) return null

  return (
    <div className={cn(styles.root, className)}>
      <p className={styles.title}>{t('Informazioni sui loghi')}</p>
      <div className={styles.list}>
        {loghi.map((logo, index) => (
          <div className={styles.dataList} key={`logo-${logo.originalFile || logo.image || index}`}>
            <div className={styles.dataRow}>
              <span>{`${t("Logo")} ${index + 1}`}</span>
            </div>
            <div className={styles.dataRow}>
              <span>{t("Dimensioni")}:</span>
              <span>{t("{0} x {1} cm", [logo.width ?? '-', logo.height ?? '-'])}</span>
            </div>
            {logo.colori?.length > 0 && (
              <div className={styles.dataRow}>
                <span>{t("Colori")}:</span>
                <span>{logo.colori?.join(", ") || '-'}</span>
              </div>
            )}
          </div>
        ))}
        {testi.map((testo, index) => (
          <div className={styles.dataList} key={`testo-${testo.text || index}`}>
            <div className={styles.dataRow}>
              <span>{`${t("Testo")} ${index + 1}`}:</span>
              <span>{testo.text || '-'}</span>
            </div>
            {testo.colore && (
              <div className={styles.dataRow}>
                <span>{t("Colore")}:</span>
                <span>{testo.colore || '-'}</span>
              </div>
            )}
            <div className={styles.dataRow}>
              <span>{t("Dimensioni")}:</span>
              <span>{t("{0} x {1} cm", [testo.width ?? '-', testo.height ?? '-'])}</span>
            </div>
            <div className={styles.dataRow}>
              <span>{t("Font family")}:</span>
              <span>{testo.fontFamily || '-'}</span>
            </div>
            <div className={styles.dataRow}>
              <span>{t("Font size")}:</span>
              <span>{testo.fontSize !== undefined ? parseFontSize(testo.fontSize) : '-'}</span>
            </div>
            <div className={styles.dataRow}>
              <span>{t("Weight")}:</span>
              <span>{testo.fontWeight || '-'}</span>
            </div>
            <div className={styles.dataRow}>
              <span>{t("Style")}:</span>
              <span>{testo.fontStyle || '-'}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FlussoPersonalizzazionePosizioneEditorInfo
